import { OperationType as GraphQLOperationType } from '__generated__/graphql';

/**
 * @deprecated OperationType is deprecated, use generated OperationType from `__generated__/graphql`
 */
enum OperationType {
  AND = GraphQLOperationType.And,
  OR = GraphQLOperationType.Or,
}

export default OperationType;
